<template>
	<div class="collateral-property-form">
		<div class="collateral-property-form__block-form">
			<form class="collateral-property-form__form" id="registrationForm">
				<h3 class="collateral-property-form__form-title">Задать вопрос</h3>
				<p class="collateral-property-form__form-desc">
					Напишите нам, если вы хотите записаться на осмотр или задать вопрос.
					Мы свяжемся с вами в ближайшее время
				</p>
				<input value="APPLICATION_FORM" type="hidden" name="code" />
				<div class="collateral-property-form__form-inputs">
					<div
						class="collateral-property-form__form-field"
						v-for="item in fields"
						:key="item.id"
					>
						<fieldset>
							<p
								class="collateral-property-form__form-placeholder"
								v-html="item.label"
							></p>
							<template v-if="item.typeHTML === 'input'">
								<input
									class="collateral-property-form__form-input"
									:type="item.type"
									:id="item.id"
									:class="item.dataId === 'phone' ? 'js--phone-mask' : ''"
									:name="item.name"
									:placeholder="item.placeholder"
									v-model="item.value"
									@input="delError(item.dataId)"
									autocomplete="off"
									:ref="item.dataId"
									:maxlength="item.dataId === 'phone' ? 17 : 100"
								/>
							</template>
							<template v-if="item.typeHTML === 'textarea'">
								<textarea
									class="collateral-property-form__form-textarea"
									:type="item.type"
									:id="item.id"
									:name="item.name"
									:placeholder="item.placeholder"
									v-model="item.value"
									@input="delError(item.dataId)"
									autocomplete="off"
									:ref="item.dataId"
									:maxlength="300"
								></textarea>
							</template>
							<span
								v-if="errors[item.dataId]"
								class="collateral-property-form__form-error"
								v-html="errors[item.dataId]"
							>
							</span>
						</fieldset>
					</div>

					<div
						class="collateral-property-form__form-field collateral-property-form__form-field_checkbox"
					>
						<label>
							<input
								class="collateral-property-form__form-checkbox"
								type="checkbox"
								:id="term.field.id"
								:name="term.field.name"
								:value="term.field.value"
								ref="term"
								@change="delError(term.field.dataId)"
							/>
							<div class="collateral-property-form__form-checkbox-custom"></div>
						</label>
						<span class="collateral-property-form__form-checkbox-text">
							<span>Согласен (-на) на </span>
							<span
								class="term-link"
								:data-href="idPersPr"
								@click.prevent="showModal"
								v-html="term.field.link.text"
							></span>
							<span> в соответствии с </span>
							<a
								class="term-link"
								href="/upload/documents/personal_data_process.pdf"
								target="_blank"
							>
								политикой
							</a>
						</span>
					</div>
					<span
						class="collateral-property-form__form-error"
						v-if="errors[term.field.dataId]"
						v-html="errors[term.field.dataId]"
					>
					</span>
				</div>
				<div class="smartcaptcha" ref="smartcaptcha"></div>
				<button
					class="collateral-property-form__form-submit"
					:class="{ disabled: formSubmiting }"
					@click.prevent="submitHandler"
				>
					Отправить
				</button>
				<teleport :key="showPopupSuccess" to="body">
					<conditions-modal />
				</teleport>
				<Transition>
					<form-success-modal
						v-if="formSuccess"
						:title="successData.title"
						:description="successData.description"
						@hide-modal="hideSuccessModal"
					/>
				</Transition>
			</form>
		</div>
		<div class="collateral-property-form__block-info">
			<div class="collateral-property-form__block-contacts">
				<p class="collateral-property-form__block-contacts-title">Контакты</p>
				<div class="collateral-property-form__block-wrapper">
					<p class="collateral-property-form__block-contacts-desc">
						Если у вас остались вопросы, вы можете сами связаться с нашими
						специалистами
					</p>
					<a class="collateral-property-form__block-contacts-link"
						>8 (495) 775 59 62</a
					>
				</div>
			</div>
		</div>
	</div>
	<ui-modal
		ref="uiModal"
		:key="showPopupSuccess"
		:target="idPersPr"
		:need-close-button="true"
		class="modal_conditions"
	>
		<template v-if="contentPersPr">
			<div
				class="ui-modal-container__header ui-modal-container__header-conditions"
				v-html="headerTitle"
			/>
			<div
				class="ui-modal-container__body ui-modal-container__body-conditions"
				v-html="contentPersPr"
			/>
		</template>
		<template v-else>
			<div class="conditions s3">
				<div class="conditions-inner" style="overflow: hidden">
					загрузка согласия...
					<my-preloader :add-class="'n-py-8 n-px-8'" />
				</div>
			</div>
		</template>
	</ui-modal>
</template>
<script>
import FormSuccessModal from '../land/property/components/FormSuccessModal'
import phoneMask from '../modules/phone-mask'
import TermModal from '../urban/derbent/components/TermModal'
import getConditions from './mixins/getCondition'
import ConditionsModal from './modals/ConditionsModal'
import axios from 'axios'
import captchaMixin from '@/js/vue-components/mixins/captcha'
export default {
	name: 'CollateralPropertyForm',
	components: {
		TermModal,
		FormSuccessModal,
		ConditionsModal,
	},
	mixins: [getConditions, captchaMixin],
	props: {
		formData: {
			type: Object,
			default: () => {},
		},
		additionalFields: {
			type: Object,
			default: () => {},
		},
	},
	emits: [],
	data() {
		return {
			apiUrl: '/api/public/form/result/add/',
			title: 'Заявка на участие',
			showPopupSuccess: false,
			submitBtnText: 'Отправить',
			formSubmiting: false,
			formSuccess: false,
			successData: {
				title: 'Ваша заявка успешно отправлена',
				text: 'Мы свяжемся с вами в ближайшее время',
			},
			img: {
				src: '/static/v2/src/img/urban/derbent/form-image.webp',
				alt: 'Заявка на участие',
				width: '640',
				height: '636',
			},
			fields: {
				fio: {
					dataId: 'fio',
					id: 'collateral-property-form-fio',
					type: 'text',
					label: 'Фамилия, имя, отчество',
					placeholder: 'Введите ФИО',
					value: '',
					name: 'form[FULL_NAME]',
					typeHTML: 'input',
				},
				phone: {
					dataId: 'phone',
					id: 'collateral-property-form-phone',
					type: 'tel',
					label: 'Телефон',
					placeholder: '+7 ХХХ ХХХ-ХХ-ХХ',
					value: '',
					name: 'form[PHONE]',
					typeHTML: 'input',
				},
				email: {
					dataId: 'email',
					id: 'collateral-property-form-email',
					type: 'email',
					label: 'E-mail',
					placeholder: 'Введите e-mail',
					value: '',
					typeHTML: 'input',
					name: 'form[EMAIL]',
				},
				question: {
					dataId: 'question',
					id: 'collateral-property-form-question',
					type: 'text',
					typeHTML: 'textarea',
					label: 'Ваш вопрос',
					placeholder: 'Введите вопрос',
					value: '',
					name: 'form[QUESTION]',
				},
			},
			idPersPr: 's3',
			term: {
				modal: {
					apiUrl: '/api/v2/content/policy/?code=',
					response: {},
					visible: false,
				},
				field: {
					dataId: 'term',
					id: 'form-image-term',
					name: 'form[agreement_id]',
					value: 's3',
					label: 'Согласен (-на) на ',
					link: {
						href: '#',
						text: 'обработку персональных данных',
					},
				},
			},
			errors: {},
			errorResponse: {
				error: false,
				text: 'Ошибка отправки формы. Перезагрузите страницу и попробуйте еще раз',
			},
		}
	},
	methods: {
		hideSuccessModal() {
			this.formSuccess = false
		},
		isNumber(evt) {
			if (evt.target.value.length <= 4) {
				const charCode = evt.which ? evt.which : evt.keyCode
				if (
					charCode === 55 ||
					charCode === 56 ||
					charCode < 48 ||
					charCode > 57
				) {
					evt.preventDefault()
				} else return
			}
			if (evt.target.value.length > 4 && evt.target.value.length <= 16) {
				const charCode = evt.which ? evt.which : evt.keyCode
				if (charCode < 48 || charCode > 57) {
					evt.preventDefault()
				}
			} else evt.preventDefault()
		},

		clearField(field) {
			this.fields[field].value = ''
			this.fields[field].clearBtn = false
		},

		delError(field) {
			this.errors[field] = ''
		},

		validateFields(fieldValue) {
			const pattern = /^[\s]+$/
			if (fieldValue.length === 0 || pattern.test(fieldValue)) {
				return false
			}

			return true
		},

		validateEmail(email) {
			let re =
				/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
			return re.test(email)
		},

		resetForm() {
			Object.values(this.fields).forEach(el => {
				el.value = ''
				el.clearBtn = false
			})

			this.$refs.term.checked = false
			this.errors = {}
		},

		checkForm() {
			this.errors = {}
			this.errorResponse.error = false

			Object.values(this.fields).forEach(el => {
				if (el.type === 'text') {
					if (!this.validateFields(el.value)) {
						this.errors[el.dataId] = 'Обязательное поле'
					}
				}

				if (el.type === 'email') {
					if (!this.validateFields(el.value)) {
						this.errors[el.dataId] = 'Обязательное поле'
					} else if (!this.validateEmail(el.value)) {
						this.errors[el.dataId] =
							'Укажите корректный адрес электронной почты'
					}
				}

				if (el.type === 'tel') {
					if (!this.validateFields(el.value)) {
						this.errors[el.dataId] = 'Обязательное поле'
					} else if (el.value.length !== 17) {
						this.errors[el.dataId] = 'Введите корректный номер телефона'
					}
				}
			})

			if (!this.$refs.term.checked) {
				this.errors[this.term.field.dataId] = 'Примите согласие'
			}

			if (Object.values(this.errors).length === 0) {
				return true
			}
		},

		resetSubmitButton() {
			this.formSubmiting = false
			this.submitBtnText = 'Отправить'
		},
		initFormJs() {
			phoneMask(document.querySelectorAll('.js--phone-mask')) // инициируем маску для телефона
		},
		getTerm() {
			new Promise(resolve => {
				axios
					.get(this.term.modal.apiUrl + this.term.field.value)
					.then(response => {
						this.term.modal.response = response.data
					})
					.catch(() => {})
			})
		},
		submitHandler() {
			if (!this.checkForm()) return

			this.formSubmiting = true
			this.submitBtnText = 'Отправка...'

			//- вызывает из ./mixins/captcha
			this.initCaptcha()
		},

		submitFormAfterCaptchaCheck(token) {
			let formData = new FormData(registrationForm)

			for (let key in this.additionalFields) {
				formData.append(key, this.additionalFields[key])
			}

			axios({
				method: 'post',
				url: this.apiUrl,
				data: formData,
			})
				.then(response => {
					this.resetSubmitButton()

					if (!response.data.success) {
						this.errorResponse.error = true
						return
					}

					this.resetForm()
					this.formSuccess = true
				})
				.catch(error => {
					this.resetSubmitButton()
					this.errorResponse.error = true
				})
		},

		termModalShow() {
			this.term.modal.visible = true
		},

		termModalHide() {
			this.term.modal.visible = false
		},
	},
	mounted() {
		this.initFormJs()
		this.getTerm()
	},
}
</script>
